import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Inventory } from 'public-contracts';
import { ModernInventoryList } from './ModernInventoryList';
import { ModernInventoryForm } from './ModernInventoryForm';

export const ModernInventoryManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingInventory, setEditingInventory] = useState<Inventory | null>(
    null
  );
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    setEditingInventory(null);
    setFormOpen(true);
  };

  const handleEditClick = (inventory: Inventory) => {
    setEditingInventory(inventory);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingInventory(null);
  };

  const handleFormSave = async (inventory: Inventory) => {
    console.log('✅ handleFormSave called, closing dialog first');
    setFormOpen(false);
    setEditingInventory(null);
    
    // Trigger refresh of the inventory list after a delay to ensure API call completes
    // Using a longer delay to ensure the POST request has fully completed
    setTimeout(() => {
      setRefreshKey((prev) => {
        console.log(`✅ refreshKey changed from ${prev} to ${prev + 1}`);
        return prev + 1;
      });
    }, 1000); // Increased delay to 1 second
  };

  return (
    <div className="container mx-auto p-6" data-testid="inventory-management">
      <ModernInventoryList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernInventoryForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        inventory={editingInventory}
      />
    </div>
  );
};
